var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.333 15.61 4.276-4.276-2.276-2.277v-4.91L1.083 1.083l3.063 12.25h4.91l2.277 2.276zm0-1.886L9.609 12H5.187L3.23 4.174 6.448 7.39a1.667 1.667 0 1 0 .943-.943L4.173 3.231l7.826 1.956V9.61l1.724 1.724-2.39 2.39zM8 8.334a.333.333 0 1 1 0-.667.333.333 0 0 1 0 .667z",
    fill: "#2D67D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen-icon.c04b28b88719c16ad849bb284ed33537.svg";
export { ForwardRef as ReactComponent };